import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';
import { FilterComponent } from './FilterComponent';
import { FORMATS } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import React from 'react';

function getDateRangeLabel(values: Array<Dayjs | null>): string | null {
	if (!values || !values.length) {
		return null;
	}

	const start = values[ 0 ]?.format(FORMATS.SHORT_DATE);
	const end = values[ 1 ]?.format(FORMATS.SHORT_DATE);

	if (!start && !end) {
		return null;
	}

	return `${start} - ${end}`;
}

export const DateFilter: FilterComponent<[Dayjs | null, Dayjs | null]> = (props) => {
	const { format, id, onChange, value } = props;

	return (
		<FilterComponent
			{ ...props }
			className='date'
			tagProps={ {
				value: getDateRangeLabel(value)
			} }>
			<DatePicker.RangePicker
				allowClear
				allowEmpty={ [ true, true ] }
				className='filter'
				format={ FORMATS.SHORT_DATE }
				getPopupContainer={ getDirectParent }
				id={ getFilterId(id) }
				onChange={ (dates) => {
					onChange({
						[ id ]: {
							format,
							value: dates as [Dayjs | null, Dayjs | null]
						}
					});
				} }
				showTime={ false }
				value={ value } />
		</FilterComponent>
	);
};
